import React, { useState, useEffect, useRef } from 'react';

const INTERVAL = 4000;

export default function AutoTabs({ items }) {
  const [active, setActive] = useState(0);
  const [pct, setPct]       = useState(0);
  const timerRef = useRef(null);

  const switchTo = i => {
    clearInterval(timerRef.current);
    setActive(i);
    setPct(0);
    start(i);
  };

  const start = (current) => {
    timerRef.current = setInterval(() => {
      setPct(p => {
        const next = p + (100 / (INTERVAL / 50));
        if (next >= 100) {
          setActive(a => {
            const n = (a + 1) % items.length;
            setPct(0);
            return n;
          });
          return 0;
        }
        return next;
      });
    }, 50);
  };

  useEffect(() => {
    start(0);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="tabs-nav rv">
        {items.map((t, i) => (
          <button
            key={i}
            className={`tab-btn${active === i ? ' active' : ''}`}
            onClick={() => switchTo(i)}
          >
            <span className="tab-num">{String(i + 1).padStart(2, '0')}</span>
            {t.label}
          </button>
        ))}
      </div>

      <div className="tabs-panel rv d1">
        {items.map((t, i) => (
          <div key={i} className={`tab-content${active === i ? ' active' : ''}`}>
            <div className="tab-inner">
              <div className="tab-icon-box">{t.icon}</div>
              <div>
                <h3>{t.title}</h3>
                <p>{t.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="tab-bar rv d2">
        <div className="tab-prog" style={{ width: `${pct}%` }} />
      </div>
    </>
  );
}
